<template>
	<div class="circle_icon" />
</template>

<script>
export default {
	name: "CircleIcon"
}
</script>
